var _style, _g, _line, _g2, _g3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDjango(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    style: {
      enableBackground: "new 0 0 96 96"
    },
    viewBox: "0 0 96 96",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;stroke:#000000;stroke-width:4;stroke-miterlimit:10;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M87,9v67.4L48.8,86.6c-0.1,0-0.4,0.1-0.8,0.1s-0.8,0-0.8-0.1L9,76.4V9h36.6h4.9H87 M90.6,3H50.4c-1.3,0-3.6,0-4.9,0H5.4   C4.1,3,3,4.1,3,5.4v73.1c0,1.3,1.1,2.7,2.4,3.1l40.3,10.7c0.7,0.2,1.5,0.3,2.4,0.3s1.7-0.1,2.4-0.3l40.3-10.7   c1.3-0.3,2.4-1.7,2.4-3.1V5.4C93,4.1,91.9,3,90.6,3L90.6,3z"
  }))), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 3,
    x2: 93,
    y1: 18,
    y2: 18
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M4,70l41.4,11.3c1.4,0.4,3.7,0.4,5.1,0L92,70"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M14.5,56.7c0-1.9,1.3-3.4,3.1-3.4s3.1,1.4,3.1,3.4c0,1.9-1.3,3.3-3.1,3.3S14.5,58.6,14.5,56.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.6,36H30l6,11.7l2.3,5.2h0.1c-0.2-2.5-0.6-5.8-0.6-8.6V36h5v23.6h-5.3l-6-11.7l-2.3-5.1h-0.1c0.2,2.6,0.6,5.7,0.6,8.5   v8.3h-5V36z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.1,36h14.4v4.5h-9.2v4.7h7.9v4.4h-7.9v5.4h9.6v4.5H47.1V36z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.9,40.5h-6.3V36h17.9v4.5h-6.3v19.1h-5.2V40.5z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDjango);
export default __webpack_public_path__ + "static/media/django.3daf205313f779c1b7ae8864dce282b7.svg";
export { ForwardRef as ReactComponent };